import { Factory } from 'rosie';

const customerId = 'example-customer-id';

Factory.define('ExternalCustomerLookup').attr('name', 'EXTERNAL_CUSTOMER_LOOKUP');

Factory.define('ExternalCustomerLookupWithDefaults')
  .extend('ExternalCustomerLookup')
  .attr('customerId', customerId);



// WEBPACK FOOTER //
// ./factories/location/external_customer_lookup.js